export enum AutomotiveAftermarketEndpoint {
  Base = '/automotive-aftermarket',
  Filters = '/filters',
  FiltersDictionary = '/filters-dictionary',
}
